import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'browse',
    loadComponent: () =>
      import('./pages/browse/browse.component').then((m) => m.BrowseComponent),
  },
  {
    path: 'product/:id',
    loadComponent: () =>
      import('./pages/product-detail/product-detail.component').then(
        (m) => m.ProductDetailComponent
      ),
  },
  {
    path: 'cart',
    loadComponent: () =>
      import('./pages/cart/cart.component').then((m) => m.CartComponent),
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./pages/admin/admin.component').then((m) => m.AdminComponent),
  },
  {
    path: 'admin/submit',
    redirectTo: 'sell'
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/profile/profile.component').then((m) => m.ProfileComponent),
  },
  {
    path: 'blogs',
    loadComponent: () =>
      import('./pages/blogs/blogs.component').then((m) => m.BlogsComponent),
  },
  {
    path: 'blog/:id',
    loadComponent: () =>
      import('./pages/blogs/blog-detail.component').then(
        (m) => m.BlogDetailComponent
      ),
  },
  {
    path: 'page/:slug',
    loadComponent: () =>
      import('./pages/static-page/static-page.component').then((m) => m.StaticPageComponent),
  },
  {
    path: 'guide',
    loadComponent: () =>
      import('./pages/guide/guide.component').then((m) => m.GuideComponent),
  },
  {
    path: 'sell',
    loadComponent: () =>
      import('./pages/sell/sell.component').then((m) => m.SellComponent),
  },
  {
    path: 'sell/dashboard',
    loadComponent: () =>
      import('./pages/sell/seller-dashboard.component').then((m) => m.SellerDashboardComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
